import React, { useState, useEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { CallApi } from '../../../Components/common/CommonFunctions'
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import { ReactComponent as Truck } from "../../../assets/images/icon_svg/truck_icon.svg";
import { ReactComponent as Uldbox } from "../../../assets/images/recovery_dahboard/records.svg";
import light_add_icon from '../../../assets/images/common/light_add_icon.png';
import pen from '../../../assets/images/common/pen.png';
// import { ReactComponent as SettingsIcon } from "../../../assets/images/settings.svg" // fallback: use emoji/FontAwesome

const InfoRow = ({ title, description }) => (
  <div>
    <h5>{title}</h5>
    <span>{description}</span>
  </div>
)

const MinuteInputRow = ({ title, description, name, value, onChange, disabled }) => (
  <div>
    <h5>{title}</h5>
    <span>
      {description.before}
      <Form.Control
        type="number"
        min={0}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}  
        style={{ display: 'inline-block', width: 70, height: 30, padding: '2px 8px', fontSize: 13, textAlign: 'center', border: '1px solid #d1d5db', borderRadius: 6, margin: '0 6px',
          background: disabled ? '#f3f4f6' : '#fff',    // visual cue
          cursor: disabled ? 'not-allowed' : 'text',
        }}
      />
      {description.after}
    </span>
  </div>
)

const RuleCard = ({ icon, title, subtitle, onSave, children, isEditing, onEdit, flat }) => (
  <div className="rules_box">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <div className="box_icon_text mb-0">
        <span className='border_icon'>{icon}</span>
        <div>
          <h3>{title}</h3>
          <p className='mb-0'>{subtitle}</p>
        </div>
      </div>
      <div>
        {isEditing
          ? <button className="email_btn" onClick={onSave}>
              <img src={light_add_icon} alt="light_add_icon" /> Save Changes
            </button>
          : <button className="edit_btn mb-1 me-1" onClick={onEdit}>
              <img src={pen} alt="pen" /> Edit
            </button>
        }
      </div>
    </div>
    {flat
      ? <div className='d-flex flex-column gap-3'>{children}</div>
      : <div className="rule_card">{children}</div>
    }
  </div>
)

const SubSection = ({ title, subtitle, children }) => (
  <div className="rule_card">
    <div className="subrule">
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
    {children}
  </div>
)

const StationRulesDetails = ({ detailsData, rules = {}, refetch  }) => {

  const [isTruckerEditing, setIsTruckerEditing] = useState(false);
  const [isOperationalEditing, setIsOperationalEditing] = useState(false);
    const [truckerForm, setTruckerForm] = useState({
    std_diff_minutes:  rules.std_diff_minutes  ?? 120,
    sta_diff_minutes:  rules.sta_diff_minutes  ?? 120,
  });

  const [operationalForm, setOperationalForm] = useState({
    rcs_rcf_before_std_minutes:    rules.rcs_rcf_before_std_minutes    ?? 120,
    rcs_rcf_after_arr_minutes:     rules.rcs_rcf_after_arr_minutes     ?? 120,
    shipments_not_departed_minutes: rules.shipments_not_departed_minutes ?? 120,
    missing_rcf_offpoint_minutes:  rules.missing_rcf_offpoint_minutes  ?? 120,
  });

  const handleTruckerChange = (e) => {
    const { name, value } = e.target
    setTruckerForm(prev => ({ ...prev, [name]: value }))
  }

  const handleOperationalChange = (e) => {
    const { name, value } = e.target
    setOperationalForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSave = (formData, successMessage, setEditing) => {
  CallApi({
    endPoint: 'rfs-monitor-settings/update-rules',
    method: 'post',
    payload: { station_rule_id: detailsData?.station_rule_id, ...formData },
    onSuccess: () => {
      toast.success(successMessage);
      setEditing(false); 
      refetch?.();
    },
    onError: (msg) => toast.error(msg),
  });
};


  return (
    <div className="station_rules_details">

      <RuleCard
        icon={<Truck />}
        title="Trucker Planning Discrepancy Rules"
        subtitle="Define the allowed time difference between airline and trucker planning before a discrepancy is created."
        isEditing={isTruckerEditing}
        onEdit={() => setIsTruckerEditing(true)}
        onSave={() => handleSave(truckerForm, 'Trucker planning rules saved successfully', setIsTruckerEditing)}
      >
        <MinuteInputRow
          title="STD Difference"
          description={{
            before: 'Create discrepancy when airline STD and trucker STD differ by more than',
            after:  'minutes.',
          }}
          name="std_diff_minutes"
          value={truckerForm.std_diff_minutes}
          onChange={handleTruckerChange}
          disabled={!isTruckerEditing}
        />

        <MinuteInputRow
          title="STA Difference"
          description={{
            before: 'Create discrepancy when airline STA and trucker STA differ by more than',
            after:  'minutes.',
          }}
          name="sta_diff_minutes"
          value={truckerForm.sta_diff_minutes}
          onChange={handleTruckerChange}
          disabled={!isTruckerEditing}
        />

        <InfoRow
          title="Boardpoint Mismatch"
          description="Create discrepancy when airline boardpoint and trucker boardpoint are different."
        />

        <InfoRow
          title="Offpoint Mismatch"
          description="Create discrepancy when airline offpoint and trucker offpoint are different."
        />

        <InfoRow
          title="AWB Count Mismatch"
          description="Create discrepancy when airline AWB count and trucker AWB count are different."
        />

        <InfoRow
          title="Weight Mismatch"
          description="Create discrepancy when airline total weight and trucker total weight are different."
        />

        <InfoRow
          title="Volume Mismatch"
          description="Create discrepancy when airline total volume and trucker total volume are different."
        />
      </RuleCard>

     <RuleCard
      flat
      icon={<Uldbox />}
      title="Operational Discrepancy Rules"
      subtitle="Define when shipment milestone issues should create a discrepancy."
      isEditing={isOperationalEditing}
      onEdit={() => setIsOperationalEditing(true)}
      onSave={() => handleSave(operationalForm, 'Operational discrepancy rules saved successfully', setIsOperationalEditing)}
    >


        <SubSection
          title="Missing RCS/RCF at Loading Station"
          subtitle="Define when missing RCS/RCF updates should create a discrepancy."
        >
          <InfoRow
            title="Truck Departed Without RCS/RCF"
            description="Create discrepancy when DEP is received, but RCS/RCF has not been received for all planned shipment pieces."
          />

          <MinuteInputRow
            title="Missing RCS/RCF Before STD"
            description={{
              before: 'Create discrepancy when RCS/RCF has not been received within',
              after:  'minutes before truck STD.',
            }}
            name="rcs_rcf_before_std_minutes"
            value={operationalForm.rcs_rcf_before_std_minutes}
            onChange={handleOperationalChange}
            disabled={!isOperationalEditing}
          />

          <MinuteInputRow
            title="Missing RCS/RCF After ARR"
            description={{
              before: 'Create discrepancy when RCS/RCF has not been received within',
              after:  'minutes after shipment ARR.',
            }}
            name="rcs_rcf_after_arr_minutes"
            value={operationalForm.rcs_rcf_after_arr_minutes}
            onChange={handleOperationalChange}
            disabled={!isOperationalEditing} 
          />
        </SubSection>

        <SubSection 
          title="Shipments Manifested"
          subtitle="Define when missing/incorrect MAN updates should create a discrepancy."
        >
          <InfoRow
            title="Shipments Not Manifested"
            description="Create discrepancy when the truck has been manifested, but not all planned shipments have received MAN."
          />
          <InfoRow
            title="Departure Without MAN"
            description="Create discrepancy when DEP is received, but one or more planned shipments have not received MAN."
          />
          <InfoRow
            title="MAN Truck Mismatch"
            description="MAN reported on different truck no. and/or truck date."
          />
        </SubSection>

        <SubSection
          title="Shipment Departed"
          subtitle="Define when missing DEP updates should create a discrepancy."
        >
          <MinuteInputRow
            title="Shipments Not Departed"
            description={{
              before: 'Create discrepancy when not all planned shipments have received DEP within',
              after:  'minutes after truck STD.',
            }}
            name="shipments_not_departed_minutes"
            value={operationalForm.shipments_not_departed_minutes}
            onChange={handleOperationalChange}
            disabled={!isOperationalEditing}
          />
          <InfoRow
            title="DEP Truck Mismatch"
            description="DEP reported on different truck no. and/or truck date."
          />
        </SubSection>

        <SubSection
          title="Shipments Received (Unloading Location)"
          subtitle="Define when missing RCF updates at the truck offpoint should create a discrepancy."
        >
          <MinuteInputRow
            title="Missing RCF at Offpoint"
            description={{
              before: 'Create discrepancy when not all planned shipments have received RCF within',
              after:  'minutes after truck STA.',
            }}
            name="missing_rcf_offpoint_minutes"
            value={operationalForm.missing_rcf_offpoint_minutes}
            onChange={handleOperationalChange}
            disabled={!isOperationalEditing} 
          />
        </SubSection>

      </RuleCard>
    </div>
  )
}

export default StationRulesDetails